<template>
  <div typeof="CourseInstance" class="price-container">
    <meta property="courseMode" content="MOOC" />
    <meta property="courseMode" content="online" />
    <span v-if="anchor" class="anchor"> R$ {{ moneyFormat(anchor) }} </span>
    <p class="price">R$ {{ mainPrice(price) }}</p>
    <!-- <span class="text-sm cent-price">
          <sup>{{ centPrice(price) }}</sup>
        </span> -->
  </div>
</template>

<script>
import Util from "@/util";

export default {
  props: {
    anchor: String,
    price: String,
  },
  methods: {
    moneyFormat(value) {
      return Util.formatBR(value);
    },
    mainPrice(price) {
      return Util.splitPrice(price)[0];
    },
    centPrice(price) {
      return Util.splitPrice(price)[1];
    },
  },
};
</script>

<style scoped lang="scss">
.price {
  white-space: nowrap;
  font-size: 1.6rem;
  line-height: 1;
  margin-bottom: 0;
  font-weight: bold;
}
.anchor {
  white-space: nowrap;
  font-size: small;
  color: #9e9e9e;
  text-decoration: line-through;
}
</style>
